<template>
  <div class="index">
    <el-header>
      <div class="menu position-relative">
        <div
          class="menu-cont d-flex align-items-center justify-content-between"
        >
          <div class="logo"></div>
          <el-menu
            :default-active="navUrl"
            class="el-menu-demo no-border"
            active-text-color="#eb7930"
            mode="horizontal"
            router
            @select="handleSelect"
          >
            <el-menu-item
              v-for="(item, i) in navList"
              :key="i"
              :index="item.url"
              :class="{
                active: item.url == navActiveVal,
                unactiv: item.url != navActiveVal,
              }"
            >
              <template slot="title">
                <span> {{ item.text }}</span>
              </template>
            </el-menu-item>
          </el-menu>
        </div>
      </div>
    </el-header>
    <!-- <el-main>
      <router-view></router-view>
    </el-main> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      navUrl: this.$route.path,
      navList: [
        {
          text: "Home",
          url: "/",
          id: 1,
        },
        {
          text: "About",
          url: "about",
          id: 2,
        },
        {
          text: "Games",
          url: "product",
          id: 3,
        },
        // {
        //   text: "Join Us",
        //   url: "join",
        //   id: 4,
        // },
        {
          text: "Contact Us",
          url: "tel",
          id: 5,
        },
      ],
      navActiveVal: "/",
      defaultName: "",
    };
  },
  watch: {
    //监听路由变化
    $route(val) {
      //路由如果变化则赋值给初始路由
      this.navUrl = val.path;
      this.navActiveVal = val.name;

      console.log("监听路由···················", val, this.navActiveVal);
    },
  },
  computed: {},
  created() {
    this.navActiveVal = this.$route.name;
  },
  methods: {
    handleSelect(key, keyPath) {
      this.navActiveVal = key;
    },
  },
};
</script>

<style lang="scss" scoped>
.index {
  width: 100%;
  // height: 100%;
}
.no-border {
}
.menu {
  // width: 1248px;

  background: rgba($color: #ffffff, $alpha: 0.9);
  box-shadow: 0px 15px 10px -15px rgba($color: #000000, $alpha: 0.3);

  z-index: 2;
  .menu-cont {
    width: 1248px;
    margin: 0 auto;
    color: #6d6d6d;
  }
  .logo {
    background: url("../../../assets/img/logo.png") no-repeat top center;
    background-size: 100% 100%;
    width: 162px;
    height: 30px;
  }
  .menu-item {
    margin-right: 40px;
  }
  .active {
    border-bottom-color: rgb(235, 121, 48) !important;
    color: rgb(235, 121, 48) !important;
  }
  .unactiv {
    border: 0;
    color: #6d6d6d;
  }
}
</style>


// WEBPACK FOOTER //
// src/layout/components/Sidebar/index.vue